// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KW_L","colBig":"styles_colBig__108qh","colSmall":"styles_colSmall__2gmDl"};